import { SegmentationResult, TrainingResult, UserDetail, UserInfo, WorkflowResultShare } from '@ca/core/models';
import { MEDResultDto } from 'src/app/core/models/med-result-dto.model';

export function getUserDetail(userInfo: UserInfo): UserDetail {
    const userDetail: UserDetail = {
        firstName: userInfo.firstName,
        id: userInfo.id,
        lastName: userInfo.lastName,
    };
    if (userInfo.email) {
        userDetail.email = userInfo.email;
    }
    if (userInfo.picture) {
        userDetail.picture = userInfo.picture;
    }
    return userDetail;
}

export function getUniqueUserIdsFromWorkflowSharesResults(items: SegmentationResult[] | TrainingResult[] | MEDResultDto[]): string[] {
    const uniqueUserIds = new Set<string>();
    items.forEach((item: SegmentationResult | TrainingResult | MEDResultDto) => {
        if (item.workflowResultShares) {
            item.workflowResultShares.forEach((share: WorkflowResultShare) => {
                if (share.userId) {
                    uniqueUserIds.add(share.userId);
                }
            });
        }
    });
    return Array.from(uniqueUserIds);
}

export function getUserDetailsFromWorkflowShares(shares: WorkflowResultShare[], userInfos: UserInfo[]): UserDetail[] {
    return shares.reduce((prev: UserDetail[], curr: WorkflowResultShare) => {
        const userInfoForShare = userInfos.find((userInfo: UserInfo) => userInfo.id === curr.userId);
        if (!userInfoForShare) {
            return prev;
        }
        prev.push(getUserDetail(userInfoForShare));
        return prev;
    }, []);
}
